// extracted by mini-css-extract-plugin
module.exports = {"title":"PageInfo__title___3KB4q","warpIA":"PageInfo__warpIA___hW0DD","warpCA":"PageInfo__warpCA___261ZT"};